<template>
  <p-dialog v-if="visible" v-model="dialog">
    <template v-slot:activator="dialogProps">
      <v-tooltip :disabled="!disabled" left>
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <v-list-item
              :disabled="disabled"
              v-on="dialogProps.on"
              v-text="passwordHardReset()"
            />
          </span>
        </template>
        <span v-text="tooltip" />
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="headline" v-text="passwordHardReset()" />
      <a-form ref="form" autocomplete="new-password" @submit="save">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="passwordValidationRules()"
                  vid="input.password"
                >
                  <v-text-field
                    v-model="password"
                    :label="passwordFieldLabel()"
                    :error-messages="errors"
                    :type="inputType"
                    :append-icon="showPasswordIcon"
                    counter
                    autocomplete="off"
                    @click:append="showPassword = !showPassword"
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|password-confirmed:input.password"
                  vid="input.passwordRepeat"
                >
                  <v-text-field
                    v-model="repeatedPassword"
                    :label="passwordRepeatFieldLabel()"
                    :error-messages="errors"
                    :type="inputrepeatedType"
                    :append-icon="showRepeatedPasswordIcon"
                    counter
                    autocomplete="off"
                    @click:append="showRepeatedPassword = !showRepeatedPassword"
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <p-password-policies :policies="passwordPolicies" />
          </v-container>

          <v-card-actions>
            <v-spacer></v-spacer>
            <a-btn outlined @click="reset()" v-text="passwordResetAbort()" />
            <a-btn
              color="primary"
              type="submit"
              v-text="passwordHardResetExecute()"
            />
          </v-card-actions>
        </v-card-text>
      </a-form>
    </v-card>
  </p-dialog>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import Form from "+/components/form/Form";
import Button from "+/components/button/Button";
import SetPasswordMutation from "../graphql/SetPasswordMutation.gql";

export default {
  components: {
    "validation-provider": ValidationProvider,
    "a-btn": Button,
    "a-form": Form
  },
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    passwordPolicies: {
      type: Array,
      default: () => {}
    },
    tooltip: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false,
    password: "",
    repeatedPassword: "",
    showPassword: false,
    showRepeatedPassword: false
  }),
  computed: {
    inputType() {
      return this.showPassword ? "text" : "password";
    },
    inputrepeatedType() {
      return this.showRepeatedPassword ? "text" : "password";
    },
    showPasswordIcon() {
      return this.showPassword ? "mdi-eye" : "mdi-eye-off";
    },
    showRepeatedPasswordIcon() {
      return this.showRepeatedPassword ? "mdi-eye" : "mdi-eye-off";
    }
  },
  methods: {
    passwordHardReset() {
      return this.$t("Security.UserAdministration.PasswordHardReset");
    },
    passwordFieldLabel() {
      return this.$t("Security.UserAdministration.PasswordFieldLabel");
    },
    passwordRepeatFieldLabel() {
      return this.$t("Security.UserAdministration.PasswordRepeatFieldLabel");
    },
    passwordHardResetExecute() {
      return this.$t("Security.UserAdministration.PasswordHardResetExecute");
    },
    passwordResetAbort() {
      return this.$t("Security.UserAdministration.PasswordResetAbort");
    },
    save() {
      this.$apollo
        .mutate({
          client: "security",
          mutation: SetPasswordMutation,
          variables: {
            input: {
              id: this.user.id,
              password: this.password
            }
          }
        })
        .then(response => {
          if (this.$refs.form.setErrorsIfExsists(response)) {
            this.dialog = false;
            this.resetPasswordSuccess();
          }
        });
    },
    resetPasswordSuccess() {
      const successMessage = this.$t(
        "Security.UserAdministration.PasswordHardResetSuccess"
      );
      this.$feedback(successMessage, {
        type: "success"
      });
    },
    reset() {
      this.password = "";
      this.repeatedPassword = "";
      this.dialog = false;
      this.$refs.form.resetFormValidation();
    },
    passwordValidationRules() {
      return {
        required: true,
        "password-policies-respected": this.passwordPolicies
      };
    }
  }
};
</script>
